// V2 版式：statement（前端 DOM 版）——对照后端 v2/layouts/statement.ts
// 单句金句占 60% 版面；左侧 accent 竖条；quote block 供料，无 quote 降级用 title。

import { SPACING } from "../../lib/tokens.generated";
import { px, pt } from "./shared";
import V2Chrome from "./Chrome";
import { isLuxe, LuxeDecorCircle } from "./luxe";
import { isTerm, consultTheme, inkTheme } from "./themes";
import { EditableText } from "../SlideCanvas";
import type { V2LayoutProps } from "./V2Slide";
import { kickerOf, footOf } from "./shared";

export default function V2Statement({ c, skin, page, total, editable, handlers }: V2LayoutProps) {
  const m = SPACING.marginX;
  const W = 13.333;
  const luxe = isLuxe(skin);
  // term（043 §4.4）：金句加 `>` 终端提示符；ink（043 §4.6）：楷体巨句大留白——字号收敛、框宽收窄居中
  const term = isTerm(skin);
  const consultT = consultTheme(skin);
  const inkT = inkTheme(skin);
  const inkQuote = inkT !== null;
  const qi = c.blocks.findIndex((b) => b.type === "quote");
  const quote = qi >= 0 ? c.blocks[qi] : null;
  const text = quote && quote.type === "quote" ? quote.text : c.title;
  const cite = quote && quote.type === "quote" ? quote.cite : c.subtitle;
  const textPath = quote ? `blocks.${qi}.text` : "title";
  const citePath = quote ? `blocks.${qi}.cite` : "subtitle";

  return (
    <>
      <V2Chrome skin={skin} kicker={kickerOf(page, "statement")} page={page} total={total} foot={footOf()} />
      {/* 裸金装饰小圆（仅 luxe） */}
      <LuxeDecorCircle skin={skin} variant="statement" />
      {/* 左侧竖条：accent（瑞士）/ hairline（杂志）；term 磷光绿；ink 黛灰细发线 */}
      <div style={{
        position: "absolute", left: px(m), top: px(2.2), width: px(0.07), height: px(2.9),
        background: inkT ? inkT.accentGrey : skin.accent,
      }} />
      {/* 金句（引号为静态装饰，不进可编辑值）；luxe 深底页用裸金金句；term 加 `>` 前缀；
          ink 字号收敛框宽收窄居中（statement.ts 分支） */}
      <div style={{
        position: "absolute", left: px(inkQuote ? m + 1.6 : m + 0.5), top: px(inkQuote ? 2.35 : 2.1),
        width: px(inkQuote ? W - 2 * m - 3.2 : W - 2 * m - 1.2), height: px(3.1),
        fontSize: pt(Math.round(skin.scale.pageTitle * (inkQuote ? 1.0 : 1.15))),
        color: luxe && skin.bg !== "paper" ? skin.accent : skin.text,
        fontFamily: skin.fontHead, fontWeight: skin.serifHead ? 700 : 400,
        lineHeight: 1.25, display: "flex", alignItems: "center",
      }}>
        <span>「</span>
        <EditableText
          value={(term ? "> " : "") + text} path={textPath} editable={editable} multiline
          // 045 #11：term `>` 前缀在持久化前剥离，防编辑把前缀存进文本叠加
          onEdit={(p, v) => handlers.onEdit?.(p, term && v.startsWith("> ") ? v.slice(2) : v)}
          onBeginEdit={handlers.onBeginEdit} onEndEdit={handlers.onEndEdit}
        />
        <span>」</span>
      </div>
      {(cite || editable) && (
        <div style={{
          position: "absolute", left: px(m + 0.5), top: px(5.35), width: px(8), height: px(0.4),
          fontSize: pt(skin.scale.caption), color: skin.sub, fontFamily: skin.fontBody,
          display: "flex", gap: 6,
        }}>
          <span>——</span>
          <EditableText
            value={cite ?? ""} path={citePath} editable={editable}
            onEdit={handlers.onEdit} onBeginEdit={handlers.onBeginEdit} onEndEdit={handlers.onEndEdit}
          />
        </div>
      )}
      {/* consult（043 §4.2）：insight 横幅——navy 满铺 so-what 条（subtitle 供料，白字）；无 subtitle 自然降级 */}
      {consultT && c.subtitle && (
        <>
          <div style={{
            position: "absolute", left: px(m), top: px(5.95), width: px(W - 2 * m), height: px(0.62),
            background: consultT.ink,
          }} />
          <div style={{
            position: "absolute", left: px(m + 0.3), top: px(5.95), width: px(W - 2 * m - 0.6), height: px(0.62),
            fontSize: pt(skin.scale.body), color: consultT.paper, fontFamily: skin.fontBody, fontWeight: 700,
            display: "flex", alignItems: "center",
          }}>{c.subtitle}</div>
        </>
      )}
    </>
  );
}
